export const ToggleChips = ({ options, values, onChange, testPrefix }) => {
  const toggle = (id) => onChange(values.includes(id) ? values.filter((v) => v !== id) : [...values, id]);
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => {
        const active = values.includes(o.id);
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => toggle(o.id)}
            data-testid={`${testPrefix}-${o.id}`}
            data-active={active}
            className={`rounded-full border px-4 py-2 font-tech text-xs uppercase tracking-wider transition-[border-color,background-color,color] duration-200 ${
              active ? "border-[#FF3333] bg-[#FF3333]/15 text-white" : "border-white/10 text-zinc-500 hover:border-white/30 hover:text-white"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};
